<script>
import { mapGetters } from "vuex";
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";
import DashboardTotal from "@/components/modules/new-dashboard/components/dashboard-total.vue";
import {formatPercentage} from "../../../../shared/utils/formatters";

export default {
  name: "TrackerOrganizationsByStatus",
  data() {
    return {
      config: {
        width: 400,
        height: 160,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 20,
      },
      certified: 0,
      recognition: 0,
      totalOrganizations: 0
    };
  },
  computed: mapGetters(["getTrackerOrganizationsByStatus"]),
  mounted() {
    this.formatAwardByStatus()
  },
  watch: {
    'getTrackerOrganizationsByStatus': {
    handler:  function() {
        this.formatAwardByStatus();
      },
      deep: true
    }
  },
  methods: {
    formatPercentage,
    formatAwardByStatus: function () {
      this.certified= this.getTrackerOrganizationsByStatus.data.filter((data)=>data._id !== 'label_tracker_dashboard_awardType_recognition').reduce((prev,curr)=>prev + curr.count,0);
      this.recognition= this.getTrackerOrganizationsByStatus.data.find((data)=>data._id ==='label_tracker_dashboard_awardType_recognition')?.count ?? 0;
      this.totalOrganizations = this.certified + this.recognition;
    },
  },
};
</script>

<template>
  <div class="organizations-container">
    <div>
      <div class="organizations-category">Certified</div>
      <div class="total-organizations">{{ certified }}</div>
      <div class="total-organizations-percentage">({{formatPercentage(totalOrganizations > 0 ?  100 *certified / totalOrganizations : 0)}}%)</div>
    </div>
    <div>
      <div><img src="../../../../assets/icons/dashboard/building.png"></div>
      <div class="grand-total-organizations">{{ totalOrganizations }}</div>
    </div>
    <div>
      <div class="organizations-category">Recognition</div>
      <div class="total-organizations">{{ recognition }}</div>
      <div class="total-organizations-percentage">({{formatPercentage(totalOrganizations > 0 ? 100*recognition / totalOrganizations : 0)}}%)</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.organizations-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 50px;
  text-align: center;
}
.organizations-category {
  font-size: 14px;
  font-family: Montserrat, sans-serif;
}
.total-organizations {
  color: #2F60A6;
  font-size: 30px;
  font-family: Montserrat-Regular, sans-serif;
}
.total-organizations-percentage{color: #2F60A6;
  font-size: 16px;
  font-family: Montserrat-Regular, sans-serif;
line-height: 0.3}
.grand-total-organizations {
  font-size: 30px;
  color: #2F60A6;
  font-family: Montserrat-Bold, sans-serif;
}
</style>
